import clsx from 'clsx';
import { memo } from 'react';

import { SharedCardProps } from '../../types/SharedCardProps';
import { Divider } from '../Divider/Divider';
import { Footer } from '../Footer/Footer';
import { Header } from '../Header/Header';
import { Layout } from '../Layout/Layout';
import './Card.css';

type CardProps = SharedCardProps;

export const Card = memo(
  ({
    children,
    header,
    footer,
    size = 'm',
    disableContentPadding,
    variant = 'default',
  }: CardProps) => {
    const footerSize = size === 's' ? 's' : 'm';
    const isEmbedded = variant === 'embedded';
    const showDividers = size !== 's';
    return (
      <Layout
        className={clsx('eds-card', `eds-card--size-${size}`, {
          'eds-card--embedded': isEmbedded,
        })}
        direction="column"
        spacing="none"
      >
        {header && (
          <>
            <Header {...header} size={header.size ?? size} />
            {showDividers && <Divider />}
          </>
        )}
        <Layout
          className={clsx(
            'eds-card--content',
            `eds-card--content--size-${size}`,
            {
              'eds-card--content--no-padding': disableContentPadding,
            },
          )}
          direction="column"
          flex="auto"
        >
          {children}
        </Layout>
        {footer && (
          <>
            {showDividers && <Divider />}
            <Footer {...footer} size={footerSize} />
          </>
        )}
      </Layout>
    );
  },
);

Card.displayName = 'Card';
